import { Alert, Text } from 'braid-design-system';
import type React from 'react';
import type { ComponentProps } from 'react';
import { SlideDown } from 'react-slidedown';

import { TextLink } from 'src/components';
import type { SuggestionType } from 'src/shared/types';

interface Props {
  tone?: ComponentProps<typeof Alert>['tone'];
  suggestion: SuggestionType;
}

const ArticleSuggest = ({ suggestion, tone = 'info' }: Props) => {
  const generateMessage = (suggestionObj: SuggestionType): React.ReactNode => {
    const { message, variables } = suggestionObj;
    if (!variables) {
      return message;
    }

    const placeholderRegex = /(%\w+)/g;
    const segments = message.split(placeholderRegex);

    return segments.map((segment, index) => {
      if (placeholderRegex.test(segment)) {
        const key = segment.replace('%', '');
        const variable = variables[key];
        if (variable) {
          return (
            <TextLink
              key={index}
              target="_blank"
              tracking={variable.tracking}
              href={variable.href}
              product={
                variable.product === 'candidate' ? 'candidate' : 'employer'
              }
            >
              {variable.label}
            </TextLink>
          );
        }
      }
      return segment;
    });
  };

  return (
    <SlideDown
      style={{
        height: 0,
        transitionProperty: 'none',
        transitionDuration: '0.3s',
        transitionTimingFunction: 'ease-in-out',
        overflowY: 'hidden',
      }}
    >
      <Alert tone={tone}>
        <Text>{generateMessage(suggestion)}.</Text>
      </Alert>
    </SlideDown>
  );
};

export default ArticleSuggest;
